'use strict'
// Lightweight browser probe policy; it grants no awards and reads no client
// metrics. The browser sends a hint, while the server verifies grant+ledger.
// Event wakeups plus one bounded continuation after a committed award. There
// is no interval, recurring idle timer or anonymous background polling.
const MIN_SIGNAL_GAP_MS = 8_000
const MAX_CEREMONIES_PER_SESSION = 34
const MIN_EVALUATION_RETRY_MS = 500
const MAX_EVALUATION_RETRY_MS = 152_000

function eligibleCeremonies(snapshot, alreadyShown = [], limit = MAX_CEREMONIES_PER_SESSION) {
  if (snapshot?.kind !== 'achievement' || snapshot.collectionId !== 'achievements' ||
      !Array.isArray(snapshot.artifacts) || snapshot.artifacts.length > 34) return []
  const seen = new Set(alreadyShown)
  return snapshot.artifacts.filter(row => row?.kind === 'achievement' &&
    row.status === 'UNLOCKED' && row.progressPercent === 100 &&
    row.celebratedAt == null && typeof row.id === 'string' &&
    !seen.has(row.id)).slice(0, Math.max(0, Math.min(34, limit)))
}
function shouldProbe({ visible, authenticated, active, inFlight, now, lastAt = 0,
  minGapMs = MIN_SIGNAL_GAP_MS } = {}) {
  return visible === true && authenticated === true && !active && !inFlight &&
    Number.isSafeInteger(now) && now > 0 &&
    (!lastAt || now - lastAt >= minGapMs)
}
function hasVerifyingAwards(snapshot) {
  return snapshot?.kind === 'achievement' && snapshot.collectionId === 'achievements' &&
    Array.isArray(snapshot.artifacts) && snapshot.artifacts.length <= 34 &&
    snapshot.artifacts.some(row => row?.kind === 'achievement' && row.status === 'VERIFYING' &&
      row.progressPercent === 99 && row.completedCriterionCount === row.criterionCount)
}
function boundedEvaluationRetryDelay(value) {
  const delay = Number(value)
  if (!Number.isSafeInteger(delay) || delay <= 0) return null
  return Math.max(MIN_EVALUATION_RETRY_MS, Math.min(MAX_EVALUATION_RETRY_MS, delay))
}
module.exports = Object.freeze({ MIN_SIGNAL_GAP_MS, MAX_CEREMONIES_PER_SESSION,
  MIN_EVALUATION_RETRY_MS, MAX_EVALUATION_RETRY_MS, eligibleCeremonies,
  hasVerifyingAwards, boundedEvaluationRetryDelay, shouldProbe })
